const selectListData = [
  { value: 'questions',          name: 'All Questions' },
  { value: 'common_questions',   name: 'All Common Questions' },
  { value: 'internal_questions', name: 'All Internal Questions' },
   { value: 'nonphoto',           name: 'Non-Photo Questions' },
  { value: 'unselect',           name: 'Unselect All Questions' } 
];

export default selectListData;
